import { post, get } from '@aiptyg/api-client';
import type { SessionDTO, UserMeDTO } from '@aiptyg/types';
import type { LoginRequest, PublicCaptchaConfig } from '../types/auth.types';

/** POST /v1/auth/login — returns session with User.Role. */
export function login(req: LoginRequest): Promise<SessionDTO> {
  const body: Record<string, unknown> = {
    email: req.email,
    password: req.password,
  };
  if (req.captchaDeviceKey) body.captchaDeviceKey = req.captchaDeviceKey;
  if (req.captchaVerifyParam) {
    body.captchaVerifyParam = req.captchaVerifyParam;
  }
  if (req.captchaTicket) {
    body.captchaTicket = req.captchaTicket;
  }
  if (req.captchaRandstr) {
    body.captchaRandstr = req.captchaRandstr;
  }
  return post<SessionDTO>('/v1/auth/login', body);
}

export function fetchPublicCaptchaConfig(): Promise<PublicCaptchaConfig> {
  return get<PublicCaptchaConfig>('/v1/public/settings/captcha');
}

/**
 * GET /v1/users/me — returns user profile.
 * Note: this endpoint does NOT return the role field.
 */
export function fetchMe(): Promise<UserMeDTO> {
  return get<UserMeDTO>('/v1/users/me');
}
